import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const host = window.location.host;

if (
  host.includes('napdev.ru') ||
  host.includes('napishem.ru') ||
  host.includes('napishem.site') ||
  host.includes('helpman24.ru')
) {
  ReactDOM.render(<App />, document.getElementById('calc_discount'));
}
